import { makeChartComp } from '../../util/makeChartComp';
var RadialBar = makeChartComp('RadialBar');
export default RadialBar;
